import React, { useEffect } from "react";
import { Form, Card, Spin, Button, Space } from "antd";
import { useChannelsPost } from "../useChannelsPost";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import PostDetails, { POST_TYPES } from "./ChannelFormComponents/PostDetails";
import Attachments from "./ChannelFormComponents/Attachments";
import TargetBatches from "./ChannelFormComponents/TargetBatches";

interface CreatePostFormProps {
  form: any;
  handleCancel: () => void;
  onSaveSuccess?: (post: any) => void;
  initialValues: any;
  isUpdating?: boolean;
  hasFullAccess?: boolean;
  handlePublish: () => void;
  batchId?: number;
  batchInfo?: any;
  initialBatchOptions?: any[];
  onDeleteAttachment?: (attachmentId: string) => void;
  activeTab?: string;
  selectedSubject?: string;
}

const CreatePostForm: React.FC<CreatePostFormProps> = ({
  form,
  handleCancel,
  onSaveSuccess,
  initialValues,
  isUpdating,
  hasFullAccess,
  handlePublish,
  batchId,
  batchInfo,
  initialBatchOptions,
  onDeleteAttachment,
  activeTab,
  selectedSubject,
}) => {
  useEffect(() => {
    if (initialValues) {
      if (initialValues.id) {
        form.setFieldsValue(initialValues);
      } else {
        form.setFieldsValue({
          ...initialValues,
          postType: activeTab,
          subject: selectedSubject,
          batchIds: [batchInfo?.value],
        });
      }
    } else {
      form.setFieldsValue({
        postType: activeTab,
        subject: selectedSubject,
        batchIds: [batchInfo?.value],
      });
    }
  }, [initialValues, activeTab, selectedSubject, batchInfo, form]);

  const { createPostWithAttachments } = useChannelsPost(form, {
    onSuccess: (savedPost: any) => {
      if (onSaveSuccess) {
        onSaveSuccess(savedPost);
        form.setFieldsValue({ Image: [], Ebook: [] });
      } else {
        handleCancel();
      }
    },
    selectedPostForUpdate: initialValues,
  });

  const handleFormFinish = (values: any) => {
    const { Image, videos, Ebook, ...rest } = values;
    const filesToUpload = [
      ...(Image || []),
      ...(videos || []),
      ...(Ebook || []),
    ].filter((f) => f.status !== "error");

    const formData = {
      ...rest,
      postType: activeTab,
      subject: selectedSubject,
      batchId,
    };
    const payload = {
      formData,
      attachments: filesToUpload,
    };

    createPostWithAttachments(BASE_URL + "post/generatePresignedUrl", payload);
  };

  const extraActions = () => {
    return (
      <Space>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button
          type="primary"
          htmlType="submit"
          loading={isUpdating}
          disabled={!hasFullAccess}
          // onClick={() => {
          //   form.submit();
          // }}
        >
          {initialValues?.id ? "Save" : "Save as Draft"}
        </Button>
        <Button
          type="primary"
          loading={isUpdating}
          disabled={!hasFullAccess || (initialValues?.id ? false : true)}
          onClick={() => handlePublish()}
        >
          Publish
        </Button>
      </Space>
    );
  };
  const newPostType =
    POST_TYPES.find((pt) => pt.value === activeTab)?.label ||
    initialValues?.postType ||
    "Post";
  return (
    <Form form={form} layout="vertical" onFinish={handleFormFinish}>
      <Card
        title={
          initialValues?.id
            ? "Edit " + newPostType
            : "Create New " + newPostType
        }
        extra={extraActions()}
      >
        <Spin size="large" spinning={isUpdating}>
          <PostDetails form={form} />
          <Attachments
            form={form}
            selectedPost={initialValues}
            hasFullAccess={hasFullAccess}
            onDeleteAttachment={onDeleteAttachment}
          />
          <TargetBatches
            form={form}
            selectedPost={initialValues}
            batchInfo={batchInfo}
            initialBatchOptions={initialBatchOptions}
          />
        </Spin>
      </Card>
    </Form>
  );
};

export default CreatePostForm;
